export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return undefined;
};

export const setCookie = (
  name,
  value,
  { days, domain, path = "/", secure = false, sameSite } = {},
) => {
  if (!value) {
    return;
  }

  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  const domainValue = domain ? `; domain=${domain}` : "";
  const pathValue = `; path=${path}`;
  const sameSiteValue = sameSite ? `; SameSite=${sameSite}` : "";
  const secureValue = secure ? "; Secure" : "";

  document.cookie = `${name}=${value}${expires}${domainValue}${pathValue}${sameSiteValue}${secureValue}`;
};

export const deleteCookie = (name, { domain, path = "/" } = {}) => {
  const domainValue = domain ? `;domain=${domain}` : "";
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC${domainValue}; path=${path}`;
};
